<template>
  <!-- <div class="red"> -->
  <v-form
    @submit.prevent="searching"
    class="mb-5"
  >
    <!-- <v-container> -->
    <v-card-title>
      <span><h4>{{ searchTitle }}</h4></span>
    </v-card-title>
    <v-card-text style="height: 100px">
      <!-- <v-col md="2"> -->
      <!-- </v-col> -->
      <!-- <v-radio-group
            v-model="search.document_type"
            row
          >
            <v-radio
              label="CPF"
              value="3"
            />
            <v-radio
              label="RG"
              value="1"
            />
            <v-radio
              label="CNH"
              value="2"
            />
          </v-radio-group> -->

      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-autocomplete
            dense
            outlined
            label="Tipo de documento"
            v-model="search.document_type"
            @change="search.document_number = null"
            clearable
            class="border__radius-15"
            :items="documentTypeList"
            item-text="type_document_name"
            item-value="id"
          />
        </v-col>
        <!-- <v-col
              cols="12"
              sm="6"
              md="5"
            >
              <v-text-field
                label="Nome"
                maxlength="255"
                v-model="search.name"
                class="border__radius-15"
                outlined
                dense
              />
            </v-col> -->
        <v-col
          cols="12"
          md="3"
          v-if="search.document_type"
        >
          <!-- NOTE - TERÁ variável search.cpf, rg e cnh -->
          <v-text-field
            label="Número do documento"
            outlined
            class="border__radius-15"
            dense
            v-mask="maskDecider"
            maxlength="14"
            v-model="search.document_number"
            required
          />
          <!-- <v-text-field
                v-else-if="search.document_type == '1'"
                label="RG"
                outlined
                class="border__radius-15"
                dense
                v-mask="'###.###.###-##'"
                maxlength="14"
                v-model="search.document_number"
                required
              />
              <v-text-field
                v-else-if="search.document_type == '2'"
                label="CNH"
                outlined
                class="border__radius-15"
                dense
                v-mask="'###.###.###-##'"
                maxlength="14"
                v-model="search.document_number"
                required
              /> -->
        </v-col>
      </v-row>
      <v-row>
        <v-menu
          v-model="dateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        />
      </v-row>
    </v-card-text>

    <div class="button_actions">
      <v-btn
        v-if="screenType == 'visitors'"
        elevation="0"
        class="border__radius-15"
        @click="redirectPatient"
        color=""
      >
        <v-icon
          size="22"
          class="icon"
        >
          mdi-keyboard-backspace
        </v-icon>
        Voltar
      </v-btn>
      <v-card-actions style="margin-right: 2rem">
        <v-spacer />
        <v-btn
          @click="btlimpar"
          class="float-end border__radius-15"
          color="blue-grey lighten-4"
          style="margin-left: 10px"
        >
          <v-icon
            size="22"
            class="icon"
          >
            mdi-broom
          </v-icon>
          <span>Limpar</span>
        </v-btn>
        <v-btn
          elevation="0"
          class="border__radius-15"
          color="green darken-1"
          dark
          type="submit"
        >
          <v-icon
            size="22"
            class="icon"
          >
            mdi-magnify-plus-outline
          </v-icon>
          Pesquisar
        </v-btn>
      </v-card-actions>
    </div>
    <!-- </v-container> -->
  </v-form>
  <!-- </div> -->
</template>

<script>
import axios from "@/axios";
import { visitorsMixin } from "../../../mixins/visitorsMixin";
export default {
  mixins: [visitorsMixin],
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    screenType: {
      type: String,
      default: "visitors",
    },
    searchTitle: {
      type: String,
      default: "Pesquisar Visitantes",
    },
  },
  data() {
    return {
      dateMenu: false,
      search: {
        document_number: null,
      },
      visitors: "",
      startNew: false,
      //Campo date
      date: "",
      documentTypeList: [],
      resultVisitors: [],
    };
  },
  created() {
    this.date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10);
    this.search.attendance_date = this.date;
    this.date = this.date.split("-").reverse().join("/");
    // this.options = {};
    // this.searching();
    this.fetchDocumentTypes()
  },

  computed:{
    maskDecider(){
      const documentID = this.search.document_type
      return documentID == 3 ? '###.###.###-##' : documentID ==  1 ? '##.###.###-##' : ''
    },
  },

  watch:{
    options(before, after){
      if(before != after)return this.searching();
    },
    'search.document_number'(before, after){
      if(before != after)return this.startNew = true
      // if(before == after)return this.startNew = false
    }
  },

  methods: {

    fetchDocumentTypes(){
      axios.get('document-type').then(({data})=>{
        this.documentTypeList = data?.data ?? data
      });
    },

    documentType(documentTypeId){
      switch (documentTypeId) {
        case 1:
          return 'RG'
        case 2:
          return 'CNH'
        case 3:
          return 'CPF'
      }
    },
    
    searching() {
      this.getPersonTypeReturnCount();
      if(this.startNew)this.options.page = 1
      this.$emit("resultVisitors", []);
      this.$emit("loading", true);
      axios
      // decisão de alteração de get para post 11/12/2024 por conta de falta de dados recebidos pelo AGHUSE
      .post(`person/search-person`, null, {
          params: {
            per_page:'10',
            page: this.options.page,
            document_number: this.search.document_number,
          }
        })
        .then((response) => {
          this.$emit("resultVisitors", response.data.data);
          this.$emit("paginationData", response.data.total);
          this.startNew = false

          if (Object.values(response.data.data).length == 0) {
            this.$swal({
              icon: "error",
              title:
                "Nenhum Visitante/Acompanhante Encontrado.",
              text: "Deseja cadastrar um novo?",
              showConfirmButton: true,
              confirmButtonText: "Sim",
              confirmButtonColor: "#43A047",
              showCancelButton: true,
              cancelButtonText: `Não`,
              reverseButtons: true,
              // timer: 3000,
            }).then((result) => {
              this.$emit("documentData", this.search);
              if(!result.isConfirmed) return
              this.getPersonTypeReturnCount();
              (this.$store.state.personTypeCount = {
                qtyVisitor: "",
                qtyEscort: "",
                save: false,
                limit: false,
              }),
              this.$store.state.viewPatient = true;
              this.$emit("formVisitors", false);
              this.$router.replace({query: { document_type: this.search.document_type, document_number: this.search.document_number }})
            });
          }
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            title: "Ocorreu um erro na pesquisa.",
            showConfirmButton: false,
            timer: 3000,
          }).then(() => {
            this.$emit("formVisitors", true);
          });
        })
        .finally(() => {
          this.$emit("loading", false);
        });
    },
    btlimpar() {
      this.search.document_number = null;
    },
    redirectPatient() {
      this.$store.state.stepperPatient = true;
      this.$store.state.stepperVisitors = false;
    },
    formatDate(date) {
      this.date = date.split("-").reverse().join("/");
    },
  },
};
</script>

<style scoped>
.swal2-title {
  font-size: 16px;
  font-family: Arial, Helvetica, sans-serif;
  color: black;
}
.button_actions {
  display: flex;

  flex-direction: row;

  justify-content: space-between;

  align-items: center;

  flex-wrap: wrap;
}
</style>